import React from 'react';

export default function CheckIcon({
  width = 16,
  height = 17,
  background = '#8DA76C',
  fill = '#FFFFFF',
  style = {},
  withoutBorder = false,
}) {
  if (withoutBorder) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 13 13"
        fill="none"
        style={style}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5307 3.14352C11.7464 3.36823 11.7464 3.7231 11.5307 3.94781L5.99626 9.71365C5.69427 10.0283 5.19112 10.0283 4.88913 9.71365L2.01101 6.71517C1.79531 6.49045 1.79531 6.13559 2.01101 5.91087V5.91087C2.23957 5.67275 2.62038 5.67275 2.84894 5.91087L5.4427 8.61309L10.6927 3.14352C10.9213 2.9054 11.3021 2.9054 11.5307 3.14352V3.14352Z"
          fill={fill}
        />
      </svg>
    );
  }

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 1.86364C4.11098 1.86364 1.36364 4.61098 1.36364 8C1.36364 11.389 4.11098 14.1364 7.5 14.1364C10.889 14.1364 13.6364 11.389 13.6364 8C13.6364 4.61098 10.889 1.86364 7.5 1.86364ZM0 8C0 3.85786 3.35786 0.5 7.5 0.5C11.6421 0.5 15 3.85786 15 8C15 12.1421 11.6421 15.5 7.5 15.5C3.35786 15.5 0 12.1421 0 8Z"
        fill={background}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2306 5.19933C11.3986 5.37435 11.3986 5.65074 11.2306 5.82575L6.92017 10.3165C6.68496 10.5615 6.29308 10.5615 6.05788 10.3165L3.81626 7.9811C3.64827 7.80608 3.64827 7.52969 3.81626 7.35467C3.99428 7.16922 4.29087 7.16922 4.46888 7.35467L6.48902 9.45929L10.578 5.19933C10.756 5.01387 11.0526 5.01387 11.2306 5.19933Z"
        fill={fill}
      />
    </svg>
  );
}
